import Loader from '@anm/components/Loader';
import { PreviewTitleCardWrapper } from '@anm/components/PreviewTitleCard';
import Masonry from '@anm/components/list/Masonry';
import { media, roundedShadowWhiteBg } from '@anm/styles/helpers';
import styled from 'styled-components';

const itemMargin = '40px';

const masonryWrapperOnMobile = media.phone`
  padding: 0;
`;

const MasonryWrapper = styled(Masonry)`
  padding: 40px;
  background-color: #fff;
  ${PreviewTitleCardWrapper} {
    overflow: hidden;
    border-radius: 10px;
    border: 1px solid rgba(1, 83, 130, 0.2);
  }

  > div {
    margin-right: ${itemMargin};
    background-clip: padding-box;
    &:last-child {
      margin-right: 0;
    }

    > div {
      ${roundedShadowWhiteBg};
      margin-bottom: ${itemMargin};
    }
  }
  ${masonryWrapperOnMobile};
`;

export const LoaderMassonry = styled(Loader)`
  margin: 50px auto;
`;

export default MasonryWrapper;
